import React, { Component } from "react";
import OdoslanieDodavky from "./OdeslaniTovaru/OdoslanieDodavky.js";
import LoadingPanel from "../common/LoadingPanel";
import OdoslanieBaliky from "./OdeslaniTovaru/OdoslanieBaliky.js";
import { odoslanieDodavkyController } from "../../controllers/odoslaniedodavky.controller";

class OdosielanieTovaruDialogContent extends Component {
    state = {
        loading: true,
        shouldReloadOdoslanieDodavky: false,
        selectedDodavkaId: null,
        selectedExpediciaId: null,
        selectedSposobDopravy: null
    };

    componentDidMount() {
        odoslanieDodavkyController.getFirstDodavkaByExpediciaId(this.props.defaultExpediciaId).then((response) => {
            this.changeselectedDodavkaId(response.iddodavka, this.props.defaultExpediciaId, response.sposobDopravy);
            this.setState({
                selectedDodavkaId: response.iddodavka,
                loading: false
            });
        });
    }

    changeselectedDodavkaId = (dodavkaId, expediciaId, sposobDopravy) => {
        this.setState({
            selectedDodavkaId: dodavkaId,
            selectedExpediciaId: expediciaId,
            selectedSposobDopravy: sposobDopravy
        });
    };

    reloadOdoslanieGrids = () => {
        this.setState({
            shouldReloadOdoslanieDodavky: true
        });
        this.props.reloadOdoslanieGrids();
    };

    renderDialogContent() {
        return (
            <div>
                <div className="col-lg-7">
                    <OdoslanieDodavky
                        changeselectedDodavkaId={this.changeselectedDodavkaId}
                        defaultSelectedDodavkaId={this.state.selectedDodavkaId}
                        shouldReloadGrid={this.state.shouldReloadOdoslanieDodavky}
                        afterReload={() => this.setState({ shouldReloadOdoslanieDodavky: false })}
                    />
                </div>
                <div id="OdoslanieBaliky" className="col-lg-5">
                    <OdoslanieBaliky
                        selectedDodavkaId={this.state.selectedDodavkaId}
                        selectedExpediciaId={this.state.selectedExpediciaId}
                        selectedSposobDopravy={this.state.selectedSposobDopravy}
                        reloadOdoslanieGrids={this.reloadOdoslanieGrids}
                    />
                </div>
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? <LoadingPanel /> : this.renderDialogContent();

        return <div>{contents}</div>;
    }
}

export default OdosielanieTovaruDialogContent;



// WEBPACK FOOTER //
// ./src/components/dialogs/OdosielanieTovaruDialogContent.js